import { format } from 'date-fns';

export const formatTimeInputValue = (date) => (date ? format(date, 'HH:mm') : '');

export const parseTimeInputValue = (day, value) => {
  if (!day || !value) return null;
  const [hours, minutes] = value.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  const next = new Date(day);
  next.setHours(hours, minutes, 0, 0);
  return next;
};

export const mobileTimeFieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgb(255 255 255 / 0.035)',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&:hover fieldset': {
      borderColor: 'rgb(255 255 255 / 0.32)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgb(240 90 90 / 0.55)',
    },
  },
  '& .MuiInputBase-input': {
    color: 'var(--ink)',
    colorScheme: 'dark',
  },
  '& input[type="time"]': {
    colorScheme: 'dark',
    accentColor: '#f05a5a',
  },
  '& .MuiInputLabel-root': { color: 'var(--ink-2)' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'var(--ink)' },
  '& input[type="time"]::-webkit-calendar-picker-indicator': {
    filter: 'invert(0.85)',
    opacity: 0.9,
  },
};
